import { fetchEntities } from 'actions/entities';
import DossierForm from 'components/dossiers/DossierForm'
import EntitiesMenu from 'components/entities/EntitiesMenu';
import dotProp from "dot-prop";
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getDossiers } from "selectors/dossiers";

const mapStateToProps = (state, ownProps) => {

  return {
    entities: getDossiers('menu')(state),
    entityName: 'dossier',
    form: DossierForm,
    item: (props) => <div>{`${props.dossier.patient?.firstName} ${props.dossier.patient?.lastName}`}</div>,
    loading: state.meta.dossier?.loading,
    error: state.meta.dossier?.error,
    totalPages: dotProp.get(state, 'meta.dossier.keyWindows.byWindow.menu.totalPages'),
    activePage: dotProp.get(state, 'meta.dossier.keyWindows.byWindow.menu.page'),
    confidentialityButton: true
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch((dispatch, getState) => {
        let activePage = dotProp.get(getState(), 'meta.dossier.keyWindows.byWindow.menu.page')
        if (!activePage) dispatch(fetchEntities('dossiers', { name: 'menu', page: 1, append: true }))
      })
    },
    onLoadMore: (activePage, totalPages) => {
      if( activePage < totalPages ) {
        dispatch(fetchEntities('dossiers', { name: 'menu', filter: {}, page: activePage + 1, append: true }))
      }
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EntitiesMenu));
